import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { ScanLine, Package, BarChart3 } from "lucide-react";
import { COMPANY } from "@/lib/company";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { user, loading } = useAuth();

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (!loading && user) return <Navigate to="/dashboard" replace />;

  return (
    <div className="min-h-screen bg-[#F4F4F0]">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-10">
        <header className="flex items-center justify-between mb-12">
          <div className="flex items-center gap-3">
            <img src={COMPANY.logoUrl} alt="MKB" className="w-12 h-12 border-2 border-black bg-white object-contain brut-shadow-sm p-1" />
            <div>
              <div className="font-heading font-black text-xl tracking-tight">{COMPANY.appName}</div>
              <div className="text-[10px] uppercase tracking-widest text-[#666]">MKB Designer Studio Pvt. Ltd.</div>
            </div>
          </div>
          <div className="text-xs uppercase tracking-widest text-[#666] hidden sm:block">B2B Garment Order System</div>
        </header>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#E63946] font-bold mb-4">
              ── INTERNAL TOOL · 5 SEAT LICENSE
            </div>
            <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.9] mb-6">
              SCAN.<br/>ORDER.<br/><span className="text-[#E63946]">SHIP.</span>
            </h1>
            <p className="text-base leading-relaxed text-[#0A0A0A] mb-10 max-w-md">
              A field-grade garment ordering console for sales agents.
              Scan barcodes. Snap live garment photos. Push orders straight to WhatsApp.
            </p>
            <button
              data-testid="google-login-btn"
              onClick={handleLogin}
              className="brut-btn brut-btn-primary text-base"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M21.6 12.227c0-.709-.064-1.39-.182-2.045H12v3.868h5.382a4.6 4.6 0 0 1-1.996 3.018v2.51h3.232c1.891-1.742 2.982-4.305 2.982-7.351z"/><path d="M12 22c2.7 0 4.964-.895 6.618-2.422l-3.232-2.51c-.896.6-2.04.955-3.386.955-2.605 0-4.81-1.76-5.595-4.123H3.067v2.59A9.996 9.996 0 0 0 12 22z"/><path d="M6.405 13.9A6.01 6.01 0 0 1 6.09 12c0-.66.114-1.302.315-1.9V7.51H3.067A9.996 9.996 0 0 0 2 12c0 1.614.386 3.14 1.067 4.49l3.338-2.59z"/><path d="M12 5.977c1.468 0 2.786.505 3.823 1.496l2.868-2.868C16.959 3.01 14.695 2 12 2 8.087 2 4.71 4.245 3.067 7.51L6.405 10.1C7.19 7.737 9.395 5.977 12 5.977z"/></svg>
              Continue with Google
            </button>
            <div className="mt-6 text-xs uppercase tracking-wider text-[#666]">
              Access restricted to authorized accounts only.
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5">
            <div className="brut-card p-5">
              <ScanLine strokeWidth={2.5} className="mb-3 text-[#E63946]" />
              <div className="font-heading font-black text-2xl">SCAN</div>
              <div className="text-xs uppercase tracking-wider text-[#666] mt-1">Barcode reader</div>
            </div>
            <div className="brut-card p-5 mt-8">
              <Package strokeWidth={2.5} className="mb-3" />
              <div className="font-heading font-black text-2xl">CAPTURE</div>
              <div className="text-xs uppercase tracking-wider text-[#666] mt-1">Live photos</div>
            </div>
            <div className="brut-card p-5">
              <BarChart3 strokeWidth={2.5} className="mb-3 text-[#2A9D8F]" />
              <div className="font-heading font-black text-2xl">REPORT</div>
              <div className="text-xs uppercase tracking-wider text-[#666] mt-1">SKU & Agent</div>
            </div>
            <div className="border-2 border-black p-5 mt-8 bg-[#0A0A0A] text-white brut-shadow">
              <div className="text-xs uppercase tracking-wider text-[#E63946] mb-2">MKB · KOLKATA 7</div>
              <div className="text-sm leading-tight mb-2">{COMPANY.address.split(",").slice(0,2).join(",")}</div>
              <div className="text-xs text-white/70 leading-relaxed">
                {COMPANY.contact1} · {COMPANY.contact2}<br/>
                Customer Care: {COMPANY.customerCare}<br/>
                {COMPANY.email}<br/>
                GST: {COMPANY.gst}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
